import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CountryService } from '../../../api/services';
import { CountryGroup } from '../../../api/models';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import { UrlService } from '../../../shared/services/url.service';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../../../guards/services/auth.service';

@Component({
  selector: 'app-all-destinations',
  templateUrl: './all-destinations.component.html',
  styleUrl: './all-destinations.component.scss',
})
export class AllDestinationsComponent {
  types: any[] | undefined;
  date: Date | undefined;
  selectedPlace: any;
  suggestions!: any[];
  destinations: CountryGroup[] = [];
  today = new Date();
  loading = false;

  frmSearch: FormGroup = new FormGroup({
    destination: new FormControl(''),
    type_id: new FormControl(undefined),
    date: new FormControl(),
  });

  constructor(
    private countryService: CountryService,
    public url: UrlService,
    private title: Title,
    public auth: AuthService,
  ) {}

  ngOnInit() {
    this.title.setTitle('SocialTravels - Destinazioni');
    this.getDestinations();
  }

  getDestinations() {
    this.loading = true;
    // this.countryService.countryControllerGetGroupsAndCountries().subscribe({
    this.countryService
      .countryControllerGetGroupsAndCountriesWithTravels()
      .subscribe({
        next: (res) => {
          this.destinations = res.data.list;

          this.loading = false;
        },
      });
  }
}
